import { navigate } from "vike/client/router"
import { url as cmsUrl } from "aldoo-ra/CMS/url"
import PubSub from "pubsub-js"
import { UserIcon } from "@heroicons/react/24/outline"

export default function AccountButton({ mounted, auth, initial, profile, texts }) {
  if (!mounted) return null

  if (auth) {
    return (
      <button
        onClick={() => navigate("/account")}
        className="w-10 h-10 rounded-full bg-theme_white text-theme_black hover:text-theme_white flex items-center justify-center text-base font-semibold hover:bg-primary_hov transition-colors overflow-hidden shrink-0"
      >
        {profile?.avatar
          ? <img src={cmsUrl(profile.avatar)} alt="" className="w-full h-full object-cover" />
          : initial}
      </button>
    )
  }

  return (
    <button
      onClick={() => PubSub.publish("signin", { redirect: "/account" })}
      className="w-10 h-10 rounded-full bg-theme_white text-theme_black hover:text-theme_white flex items-center justify-center hover:bg-primary_hov transition-colors shrink-0"
      title={texts?.signin}
      aria-label={texts?.signin}
    >
      <UserIcon className="w-5 h-5" />
    </button>
  )
}